export default __webpack_public_path__ + "static/media/sidebarPattern.fe389458.png";